import packageData from "@/../package.json"

export const version = packageData.version

export const apiUrl: string = "https://spicysparks.com"
export const authUrl: string = "https://accounts.spicysparks.com"
export const exaUrl: string = "https://exa.spicysparks.com"

export const googleAnalyticsId: string = "G-28EQ59LECF"
